// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fk-0";
export var fileCarousel = "_fk-2";
export var removeFileButton = "_fk-1";